<template>
  <router-view/>
</template>
<script>

export default {
  name: 'CustomersView'
}
</script>



// WEBPACK FOOTER //
// src/views/app/customers/customers-view.vue